import { BleedingCard, Cell, colors, List, Row, Separator, Skeleton } from '@fs/zion-ui'
import React from 'react'

/**
 * Displays a loading skeleton for the household list while data is being fetched.
 *
 * @component
 * @returns {JSX.Element} List of skeleton loading items
 */
const LoadingList = () => {
  return (
    <>
      <BleedingCard backgroundColor={colors.gray02} marginY="xs">
        <Row>
          <Cell growX>
            <Skeleton.H5 />
            <Skeleton.Paragraph size="xs" secondary />
          </Cell>
          <Skeleton.Button width={72} />
        </Row>
      </BleedingCard>
      <Separator size="nano" />
      <List>
        <Skeleton.ListItem hasAvatar hasSecondLine />
        <Skeleton.ListItem hasAvatar hasSecondLine />
        <Skeleton.ListItem hasAvatar hasSecondLine />
      </List>
      <Skeleton.Button width={150} maxWidth={150} />
    </>
  )
}

export default LoadingList
